import './footer.scss';


const Footer = ()=>{
    return(
        <footer>
            <span>Frontend Dashboard</span>
            <span>@copy right admin dashboard</span>
        </footer>
    )
}

export default Footer;